<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle  :lang="lang.Middle"></Middle>
            <Right v-show="isVisibleRight" :lang="lang.Right" class="PartDetailsRight"></Right>

 </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartDetails/Left/Left'
import Middle from '@/components/PartManager/Views/PartDetails/Middle/Middle'
import Right from '@/components/PartManager/Views/PartDetails/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'


export default {
  name: 'PartDetails',
  components:{
    Left,
    Middle,
    Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    routingData: Object,
    lang: Object
  },
}
</script>


<style scoped>
  .PartDetailsRight{
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDetails.vue